// export * from "./drag-drop";

import { lazy, Suspense } from "react";

const MPDDragDropComponent = lazy(() => import("./drag-drop" /* webpackChunkName: "dnd" */));

export const MPDDragDrop = (props) => {
    return (
        <Suspense fallback={null}>
            <MPDDragDropComponent {...props} />
        </Suspense>
    );
};
